import { gql } from "@apollo/client";

export const getTopLenses = gql`
    query getTopLenses(
        $sortBy: MetricField!
        $granularity: ReportingGranularity!
        $fieldsList: [OrganicStatsFieldInput!]!
        $startTime: GoogleProtobufTimestampInput
        $endTime: GoogleProtobufTimestampInput
        $limit: Int = 60
    ) {
        getMyLensesOrganicStats(
            input: {
                assetType: USER
                breakdownAssetType: LENS
                granularity: $granularity
                startTime: $startTime
                endTime: $endTime
                fieldsList: $fieldsList
                sortBy: $sortBy
                sortDirection: SORT_DIRECTION_DESC
                limit: $limit
            }
        ) {
            responseEntryList {
                assetId
                assetType
                statsResponseTimeEntryList {
                    statsList {
                        statsList {
                            value
                            dimensionBreakdown
                        }
                    }
                }
            }
        }
    }
`;
